import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './customerlist.css';

const CustomerList = ({ userName, userRole }) => {
    const [customers, setCustomers] = useState([]);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [sortOption, setSortOption] = useState('');
    const [loading, setLoading] = useState(true); // Loading state
    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        if (!userName || !userRole) return;

        setLoading(true);
        const endpoint = userRole === 'User'
            ? `${baseUrl}api/ProspCustomers/GetAllCustomersOfUser?userEmail=${userName}`
            : `${baseUrl}api/ProspCustomers/GetAllCustomers`;

        axios.get(endpoint)
            .then(response => {
                setCustomers(response.data);
                setFilteredCustomers(response.data);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }, [userName, userRole, baseUrl]);

    useEffect(() => {
        let updatedCustomers = [...customers];

        if (filterText) {
            const filter = filterText.toLowerCase();
            updatedCustomers = updatedCustomers.filter(customer =>
                (customer.vcmx2 && customer.vcmx2.toLowerCase().includes(filter)) ||
                (customer.vcmx1 && customer.vcmx1.toLowerCase().includes(filter)) ||
                (customer.vcmx3 && customer.vcmx3.toLowerCase().includes(filter)) ||
                (customer.vcmx4 && customer.vcmx4.toLowerCase().includes(filter))
            );
        }

        if (sortOption === 'alphabetical') {
            updatedCustomers.sort((a, b) => a.vcmx2.localeCompare(b.vcmx2));
        } else if (sortOption === 'newest') {
            updatedCustomers.sort((a, b) => b.msextmjIndex - a.msextmjIndex);
        } else if (sortOption === 'oldest') {
            updatedCustomers.sort((a, b) => a.msextmjIndex - b.msextmjIndex);
        }

        setFilteredCustomers(updatedCustomers);
    }, [filterText, sortOption, customers]);

    const handleViewDetailsAndStocks = (customerId) => {
        navigate(`/customer-view/${customerId}`);
    };

    const handleEditCustomer = (customerId) => {
        navigate(`/customer-edit/${customerId}`);
    };

    const handlePhoneClick = (phoneNumber) => {
        if (phoneNumber) {
            // For mobile devices, this will trigger the phone dialer
            window.location.href = `tel:${phoneNumber}`;
        }
    };

    return (
        <div className="main-layout">
            <div className="main-content">
                <div className="container mt-5">
                    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap header">
                        <h1>Customers</h1>
                        <div className="d-flex gap-2 flex-wrap filter-sort">
                            <input
                                type="text"
                                placeholder="Filter by Name, Company, Contact, or Address"
                                className="form-control"
                                value={filterText}
                                onChange={e => setFilterText(e.target.value)}
                            />
                            <select
                                className="form-select"
                                value={sortOption}
                                onChange={e => setSortOption(e.target.value)}
                            >
                                <option value="">Sort by</option>
                                <option value="alphabetical">Alphabetical</option>
                                <option value="newest">Newest First</option>
                                <option value="oldest">Oldest First</option>
                            </select>
                        </div>
                    </div>
                    
                    {/* Show loading spinner if loading */}
                    {loading ? (
                        <div className="d-flex justify-content-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="row row-cols-1 row-cols-md-3 g-4">
                            {filteredCustomers.map(customer => (
                                <div className="col" key={customer.msextmjIndex}>
                                    <div className="card h-100 custom-card shadow-sm">
                                        <div className="card-body">
                                            <h5 className="card-title custom-card-title">{customer.vcmx2}</h5>
                                            <p className="card-text">
                                                <strong>Company:</strong> {customer.vcmx1}<br />
                                                <strong>Contact:</strong> 
                                                {customer.vcmx3 ? (
                                                    <span 
                                                        className="phone-number" 
                                                        onClick={() => handlePhoneClick(customer.vcmx3)}
                                                        style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'underline' }}
                                                    >
                                                        {customer.vcmx3}
                                                    </span>
                                                ) : (
                                                    'N/A'
                                                )}
                                                <br />
                                                <strong>Address:</strong> {customer.vcmx4}
                                            </p>
                                            <div className="d-flex justify-content-between">
                                                <button
                                                    className="btn btn-view-details"
                                                    onClick={() => handleViewDetailsAndStocks(customer.msextmjIndex)}
                                                >
                                                    View Details
                                                </button>
                                                <button
                                                    className="btn btn-edit"
                                                    onClick={() => handleEditCustomer(customer.msextmjIndex)}
                                                >
                                                    <i className="bi bi-pencil"></i> Edit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CustomerList;
